/**
 * Deterministic stand-in for a real backend check (no endpoint exists yet).
 * Roughly 1/3 of customer ids resolve active, so both UI states are
 * reachable while manually testing the search-and-select flow.
 */
export function isMockActiveSignatory(customerId: string): boolean {
  let bucket = 0;
  for (const char of customerId) {
    bucket = (bucket * 31 + (char.codePointAt(0) ?? 0)) % 3;
  }
  return bucket < 1;
}
